<template>
  <div id="RecibodeFirma_div" hidden>
    <div id="encabezado-" class="form-inline justify-content-between">
      <h5>{{tituloDeInformacion}}</h5>
    </div>
    <hr class="mt-2" />
    <div>


      <h5 v-if="ReciboFirmas">{{ImprimirRecibodeFirma()}}</h5>



      <div  id="vistaprevia">


      <div  class="text-left" id="logo_div">  

        
        
          <img style="width: 15%" src="../../../assets/logo-pj-transparente-negro-recibo-2.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />
        

      </div>

      <div class="d-flex" style="height: 15px;">
    
        

   
        </div>


       <div class="text-left" id="supremo_div">  

       <h6>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h6>

        </div>

        

        <div class="text-left" id="fecha_ultima_firma_div">  

       <h6>Aguascalientes, Ags., a {{fecha_ultima_firma}} </h6>

        </div>

        <div class="text-left" id="div">  

       

        </div>


        <div class="text-left" id="nombre_div">     
          <h6>Nombre:</h6>

         <h6> {{nombre}} {{apellido_paterno}} {{apellido_materno}} </h6>

        </div>
    

    <div class="text-left" id="clave_del_procesado_div">
          <h6>Clave:  {{clave_del_procesado}} </h6>
          
        
    </div> 

    <div class="text-left" id="fecha_proxima_firma_div">
          <h6>Su Próxima Firma Es:</h6>
         
        <h6> {{fecha_proxima_firma}} </h6>

    </div> 

    <div style="white-space: pre-line;" class="text-left" id="mensaje_div">
          <h6>Mensaje:</h6>
  
         

         <span><h6> {{mensaje}} </h6> </span>

    </div>


    <div class="text-left" id="codigoqr_div">
        <h6>Codigo QR: 

       
       
       </h6>


       

       <!--   <qr style="width: 15%; display: inline-block"   :text="firmaidqr+espacio+firma_id+espacio+comaqr+claveqr+espacio
       +clave_del_procesado+espacio+comaqr+nombreqr+espacio+nombre+espacio+apellido_paterno+espacio
       +apellido_materno+espacio+comaqr+fechaqr+espacio+fecha_de_registro" ></qr> -->


       <qr 

       

       style="width: 10%; display: inline-block"   :text="hash" >
         

       </qr>

         

       

       


       <!-- <h6> <qr style="width: 15%" :text="firmaidqr+espacio+firma_id+espacio+comaqr+procesadoidqr+espacio
       +procesado_id+espacio+comaqr+nombreqr+espacio+nombre+espacio+apellido_paterno+espacio
       +apellido_materno+espacio+comaqr+fechaqr+espacio+fecha_de_registro" class="qrticket"></qr> </h6> -->

      <!--  <h6> <qr style="width: 15%" :text="firmaidqr+espacio+firma_id+espacio+comaqr+procesadoidqr+espacio
       +procesado_id+espacio+comaqr+nombreqr+espacio+nombre+espacio+apellido_paterno+espacio
       +apellido_materno+espacio+comaqr+fechaqr+espacio+fecha_de_registro" class="qrticket"></qr> </h6> --> 

    </div>


    </div>














     

       <div  id="printMe7" hidden>


      <div  class="text-center" id="logo_div">  

        
        
          <img style="zoom: 50%" src="../../../assets/logo-pj-transparente-negro-recibo-2.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />
        

        <div class="d-flex" style="height: 15px;">
    
        

   
        </div>


      

       <h6 style="font-size: 14px;">H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h6>

        
      <div>
        <p>
          

        </p>
      </div>
        

        <div>
          
       <h6 style="font-size: 14px;">Aguascalientes, Ags., a {{fecha_ultima_firma}} </h6>


        </div> 


        <div>
          
          <p>
            
          </p>
        </div>       

       
       

      
         <div>
           
        <b style="font-size: 14px;">Nombre:</b>

         <p style="font-size: 14px;"> {{nombre}} {{apellido_paterno}} {{apellido_materno}} </p>



         </div>
         
          
        <div>
          
       <b style="font-size: 14px;">Clave:</b>     <p style="font-size: 14px;">   {{clave_del_procesado}}  </p>

        </div>

   
          
          
        
   

    
          <b style="font-size: 14px;">Su Próxima Firma Es:</b>
         
        <p style="font-size: 14px;"> {{fecha_proxima_firma}} </p>


   

    <div style="white-space: pre-line;" class="text-center" id="mensaje_div">
          <b style="font-size: 14px;">Mensaje:</b>
  
         <p></p>

         <span><p style="font-size: 14px;"> <em> <u> {{mensaje}} </u> </em> </p>  </span>

    </div>


     <div>
      <p>
      
      </p>
     </div>

         
         <div>

          <p></p>


          <b style="font-size: 14px;">Código QR: </b>

          <p></p>

           


         </div>
    
        

       

       <!--   <qr style="width: 15%; display: inline-block"   :text="firmaidqr+espacio+firma_id+espacio+comaqr+claveqr+espacio
       +clave_del_procesado+espacio+comaqr+nombreqr+espacio+nombre+espacio+apellido_paterno+espacio
       +apellido_materno+espacio+comaqr+fechaqr+espacio+fecha_de_registro" ></qr> -->





       <div>


        <qr  style="display: inline-block ;zoom: 40%"   :text="direccionurl+'/Firmas/VerificacionDeFirmas?qr='+hash" ></qr>

         


       </div>


       <div>
          
          <p>
            
          </p>
        </div>



        <div>
          
       <b style="font-size: 14px;">Código de verificación QR:</b>     <p style="font-size: 14px;">   {{hash}}  </p>

        </div>


        <div>
           
        <b style="font-size: 14px;">Para verificar los datos contenidos en el presente recibo ingrese a la página ó escanee el código QR:</b>

         <p style="word-break: break-all; font-size: 14px;"> {{direccionurl+'/Funciones/VerificacionDeFirmas'}} </p>



         </div>


         <div>

          <b style="font-size: 14px;" >Para consultar el aviso de privacidad ingrese a la página:</b>
          <p  style="word-break: break-all; font-size: 14px;"> {{direccionurl+'/Micrositio/UT/Difusion'}} </p>
           

         </div>






         
         

       

       


       <!-- <h6> <qr style="width: 15%" :text="firmaidqr+espacio+firma_id+espacio+comaqr+procesadoidqr+espacio
       +procesado_id+espacio+comaqr+nombreqr+espacio+nombre+espacio+apellido_paterno+espacio
       +apellido_materno+espacio+comaqr+fechaqr+espacio+fecha_de_registro" class="qrticket"></qr> </h6> -->

      <!--  <h6> <qr style="width: 15%" :text="firmaidqr+espacio+firma_id+espacio+comaqr+procesadoidqr+espacio
       +procesado_id+espacio+comaqr+nombreqr+espacio+nombre+espacio+apellido_paterno+espacio
       +apellido_materno+espacio+comaqr+fechaqr+espacio+fecha_de_registro" class="qrticket"></qr> </h6> --> 

    

   













    </div  >

      </div  >



    <div class="d-flex" style="height: 50px;">
    <div class="vr"></div>
    </div>

    <!-- <hr class="mt-5" /> -->


    

    </div>
    
    <!-- Botones imprimir y cancelar -->

    <div class="d-flex row">
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 pb-2 text-left">
            
            <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirRecibodeFirma()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>



             <button type="button" class="btn btn-danger overwrapDeBotones mr-3"  @click="Botoncancelar()"><i class="fas fa-window-close fa-lg"></i>&nbsp;&nbsp;Cancelar</button>
        </div>





        <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"> </div>
        
    </div>


  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import catalogos from '@/../static/js/catalogos'
  import { mapActions } from 'vuex'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'
  import VueHtmlToPaper from 'vue-html-to-paper';
  import VueQRCodeComponent from 'vue-qrcode-component'



//   const options = {
//   "name": "_blank",
//   "specs": [
//     "fullscreen=yes",
//     "titlebar=yes",
//     "scrollbars=yes"
//   ],
//   "styles": [

//     "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
//     "https://unpkg.com/kidlat-css/css/kidlat.css"
//   ],
//   "timeout": 4000,
//   "autoClose": true,
//   "windowTitle": ""
// }


  

  Vue.use(VueMask);
  Vue.use(VueHtmlToPaper);
  Vue.component('qr', VueQRCodeComponent)

  export default {
    data() {
      return {

        opciones: {
       "name": "_blank",
       "specs": [
       "fullscreen=yes",
       "titlebar=yes",
       "scrollbars=yes"
     ],
     "styles": [

    // "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.min.js",
    // "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css",

      "/static/js/bootstrap@5.2.3.min.js",
      "/static/css/bootstrap@5.2.3.min.css",
      "/static/css/recibodefirma.css",


      // Nota: si no carga los estilos del recibo de firma en node_modules en la carpeta vue-html-to-paper en la carpeta dist en el archivo
      // index.js modificar en la linea 57 y 58 y cambiar de "const" a "let" y guardar los cambios



     ],
     "timeout": 4000,
     "autoClose": true,
     "windowTitle": ""
     },



        enumeraciones,
        nombre:null,
        apellido_paterno: null,
        apellido_materno: null,
        clave_del_procesado: null,
        temporalidad: null,
        fecha_proxima_firma: null,
        mensaje: "",
        espacio: " ",
        fecha_de_registro: null,
        firma_id: null,
        direccionurl: "",  

        observaciones:null,

        nombreqr: "Nombre:",
        fechaqr: "Fecha del registro:",
        claveqr: "Clave del procesado:",
        comaqr: ", ",
        firmaidqr: "Firma Id:",
        procesadoidqr: "Procesado Id:",


      }
    },
    props: {
      esAlta:true,
      tituloDeInformacion: String,
      ReciboFirmas:Object,
      DireccionUrl: String,

    },
    
    /**
     * Método encargado de cargar valores predetermidados en caso de haberlos.
     */
    beforeMount() { 



      if(this.ReciboFirmas.Nombre)
        this.nombre = this.ReciboFirmas.Nombre;

      if(this.ReciboFirmas.ApellidoPaterno)
        this.apellido_paterno = this.ReciboFirmas.ApellidoPaterno;
      else this.apellido_paterno = ""

      if(this.ReciboFirmas.ApellidoMaterno)
        this.apellido_materno = this.ReciboFirmas.ApellidoMaterno;
      else this.apellido_materno = ""


      if(this.ReciboFirmas.ClaveDelProcesado)
        this.clave_del_procesado = this.ReciboFirmas.ClaveDelProcesado;


      if(this.ReciboFirmas.FechaProximaFirma)
        this.fecha_proxima_firma = moment(this.ReciboFirmas.FechaProximaFirma).locale('es').format('LLLL');

      if(this.ReciboFirmas.FechaUltimaFirma)
        this.fecha_ultima_firma = moment(this.ReciboFirmas.FechaUltimaFirma).locale('es').format('LL');

      if(this.ReciboFirmas.MensajeUltimaFirma)
        this.mensaje = this.ReciboFirmas.MensajeUltimaFirma;
      else this.mensaje = "Sin ningún mensaje"

      if(this.ReciboFirmas.FechaDeRegistro)
        this.fecha_de_registro = (this.ReciboFirmas.FechaDeRegistro);

      if(this.ReciboFirmas.FirmaId)
        this.firma_id = (this.ReciboFirmas.FirmaId);

      if(this.ReciboFirmas.ProcesadoId)
        this.procesado_id = (this.ReciboFirmas.ProcesadoId);

      if(this.ReciboFirmas.Hash)
        this.hash = (this.ReciboFirmas.Hash);

      if(this.DireccionUrl)
        this.direccionurl = (this.DireccionUrl);        




    },
    methods: {
      



      /**
       * Función encargada de imprimir el recibo de la firma
       */
      ImprimirRecibodeFirma:function()
      {

       
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Está por generar el recibo, si decide continuar se generara el recibo para el Procesado. <br />¿Desea continuar?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Recibo'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {
                Promise.resolve(this.opciones).then(f => {
                  this.$htmlToPaper('printMe7',this.opciones);
                })
              // setTimeout(()=>{
              //  this.$htmlToPaper('printMe7',this.opciones);
                
              // }, 1)


                if(respuestaContinuar){

                  this.$emit("botoncancelarimprimir");
                  // this.$emit("restablecervalores");


                }

                
              }

              else{

              this.$emit("botoncancelarimprimir");


              }



            }
          });

      },


      Botoncancelar:function()
      {

       
     
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Está por cancelar la impresión del recibo.<br />¿Desea continuar?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {

                this.$emit("botoncancelarimprimir");

                if(respuestaContinuar){      


                }

                
              }
            }
          });


               

      },






    }



  }
</script>
<style scoped>
  .contenedor-puntero {
    background: #212529;
    border-radius:2px;
    padding: 10px;
    border:1px solid white;
    margin-bottom: 1.5em;
  }
  .form-control:disabled, .form-control[readonly]
  {
    background-color: #3D3C40 !important;
    pointer-events: none;
    color: #aaa;
  }
  ul { 
    list-style: none;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .contenedor-color-gris {        
        background-color: #9ea1a3;
        /*box-shadow: 0px 6px 20px 8px #161616;*/
        padding: 25px
    }


  .cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    overflow: hidden;

}

 .img-container {
        text-align: center;
      }


   .centradoqr {
  text-align: center;
}


.image {
    width: 300px;
    height: 300px;
    padding: 20px;
    margin: 30px;
    border: 5px solid red;
}


.qrticket{
      
      
        word-wrap: break-word;
      
    }




</style>



// WEBPACK FOOTER //
// src/components/SIVAC/Firmas/RecibodeFirma.vue